// extracted by mini-css-extract-plugin
module.exports = {"pck1":"VariantPick_pck1__1MgUS"};